  jQuery(function($) {

    $('a[href*="#"]:not([href="#"])').click(function () {
      if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
          var target = $(this.hash);
          target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
          if (target.length) {
              $('html, body').animate({
                  scrollTop: target.offset().top
              }, 1000);
              return false;
          }
      }
  });
  
   /* Accordion */

   $( ".show-menu" ).click(function() {
      $( '.header-contact, #menu-top-menu, .menu-menu-container' ).toggleClass( "show-menu-block" );
      
      $(this).attr('aria-expanded', function (i, attr) {
         return attr == 'true' ? 'false' : 'true'
     });
      
    });

    $( '.play-vid' ).click(function() {
        $('.video-frame').attr("src", $(this).attr("vidUrl"));
        $( '.video-overlay' ).delay(500).fadeIn(500);
    });

    $( '.close-video' ).click(function() {
        $( '.video-overlay' ).fadeOut(500, function(){
            $('.video-frame').attr("src", '');
        });
    });

    
    $( ".show-form" ).click(function() {
      $( ".sell-form-head" ).slideToggle( 500, function() {
         $( ".sell-form" ).slideToggle( 1000, function() {
            // Animation complete.
          });
      });
    });

    $( ".close-form" ).click(function() {
      $( ".sell-form" ).slideToggle( 1000, function() {
        $( ".sell-form-head" ).slideToggle( 500, function() {});
      });
    });

    $( ".close-box svg" ).click(function() {
      $( ".modal-banner" ).slideUp( 500 );
    });


    /* Minpack Overlay */

    $( '.mini-pack-link' ).click(function() {
      $( '.mini-pack-dl' ).attr("href", $(this).attr("minipackurl"));
      $( '.minipack-overlay' ).fadeIn(500);
    });

    $( '.close-form' ).click(function() {
      $( '.minipack-overlay' ).fadeOut(500);
    });



    $( '.payment-terms' ).click(function() {
      $( '.payment-terms-overlay' ).fadeIn(500);
    });

    $( '.payment-terms-overlay .close-box' ).click(function() {
      $( '.payment-terms-overlay' ).fadeOut(500);
    });

    $(document).on('gform_confirmation_loaded', function(event, formId){
      if(formId == 5) {
        $( '.mini-pack-dl-box' ).fadeIn(500);
      }
  });

  $('.owl-carousel').owlCarousel({
    center: true,
    margin: 10,
    nav: true,
    loop: true,
    navText:["<div class='nav-btn prev-slide'></div>","<div class='nav-btn next-slide'></div>"],
    responsive: {
        0: {
            items: 1
        },
        1060: {
            items: 1
        },
        1200: {
            items: 3
        }
    }
});





  var $container = jQuery('.acc-body'), $acc_head = jQuery('.acc-head');

		$acc_head.last().addClass('last');
		
		$acc_head.on('click', function(e) {
			if( jQuery(this).next().is(':hidden') ) {
			    //Comment or uncomment the line below to control other open accordions when acc-head is clicked.
				//$acc_head.removeClass('active').next().slideUp(300);
				jQuery(this).toggleClass('active').next().slideDown(300);
				
			}
          else{
              //Comment or Uncomment out the line below to add or remove the toggle function from acc-head
            jQuery(this).toggleClass('active').next().slideToggle(300);
          }
			e.preventDefault();
		});


  $( '.play-vid' ).click(function() {
      $('.video-frame').attr("src", $(this).attr("vidUrl"));
      $( '.video-overlay' ).delay(500).fadeIn(500);
  });

  $( '.close-video' ).click(function() {
      $( '.video-overlay' ).fadeOut(500, function(){
          $('.video-frame').attr("src", '');
      });
  });

   $(window).scroll(function(){
      var threshold = 200; // number of pixels before bottom of page that you want to start fading
      var winPos = $(window).scrollTop() / threshold;
       if( winPos <= 0 ){
          $(".top-bar, .lets-talk-btn").stop().removeClass('fade-in');
       } else {
          $(".top-bar, .lets-talk-btn").stop().addClass('fade-in');
       }
    });

     /**
 * Author: Heather Corey
 * jQuery Simple Parallax Plugin
 *
 */
 
(function($) {
 
   $.fn.parallax = function(options) {

       var windowHeight = $(window).height();

       // Establish default settings
       var settings = $.extend({
           speed        : 0.15
       }, options);

       // Iterate over each object in collection
       return this.each( function() {

          // Save a reference to the element
          var $this = $(this);

          // Set up Scroll Handler
          $(document).scroll(function(){

                 var scrollTop = $(window).scrollTop();
                      var offset = $this.offset().top;
                      var height = $this.outerHeight();

         // Check if above or below viewport
        if (offset + height <= scrollTop || offset >= scrollTop + windowHeight) {
           return;
        }

        var yBgPosition = Math.round((offset - scrollTop) * settings.speed);

                // Apply the Y Background Position to Set the Parallax Effect
            $this.css('background-position', 'center ' + yBgPosition + 'px');
               
          });
       });
   };
 
 
 $(window).scroll(function(){
   $(".fadey").css("opacity", 1 - $(window).scrollTop() / 1500);
   $(".fadey-fast").css("opacity", 1 - $(window).scrollTop() / 750);
   $(".move-down").css("margin-top", 1 + $(window).scrollTop() * 0.25);
   $(".move-up").css("margin-top", 1 - $(window).scrollTop() * 0.25);
   $(".slide-right").css("left", 1 + $(window).scrollTop() * 0.25);
   $(".slide-right").css("left", 1 + $(window).scrollTop() * 0.25);
   var pixs = $(document).scrollTop()
   pixs = pixs / 250;
   $(".blurry").css({
       "-webkit-filter": "blur(" + pixs + "px)",
       "filter": "blur(" + pixs + "px)"
   });
   var scaleUp = 1 + $(document).scrollTop() / 3000;
   var scaleDown = 1 - $(document).scrollTop() / 3000;
   $(".scale-up").css("transform", "scale( " + scaleUp + ")");
   $(".scale-down").css("transform", "scale( " + scaleDown + ")");
   var theta = $(window).scrollTop() / 300 % Math.PI;
   $('.rotate').css({
       transform: 'rotate(' + theta + 'rad)'
   });
   $('#rightgear').css({
       transform: 'rotate(-' + theta + 'rad)'
   });
 });
 
}(jQuery));



    $(".reset-filters").click(function () {
      //location.reload(true);
      $(".buy-list-col div").show();
      $('#filters input').prop('checked', false);
      $( ".buy-nav-col" ).find('.acc-head').removeClass( 'active' );
      $( ".acc-body" ).slideUp(300);
    });

    $("#filters :checkbox").click(function() {
      $(".buy-list-col div").hide();
      $("#filters :checkbox:checked").each(function() {
          $("." + $(this).val()).show();
      });
   });


    });

         
